import type {
  CSVColumnResponse,
  CSVTableHeader,
  CSVUploadSummary,
  CSVUploadSummaryResponse,
} from './CSVUpload.types'

export type QueryParams = Record<
  string,
  string | number | boolean | undefined | null
>

export function buildPathWithQuery(path: string, queryParams: QueryParams) {
  const searchParams = new URLSearchParams()

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.set(key, String(value))
    }
  })

  const queryString = searchParams.toString()
  return queryString.length > 0 ? `${path}?${queryString}` : path
}

function normalizeColumns(response: CSVColumnResponse | undefined) {
  return {
    requiredColumns: response?.required_columns ?? [],
    optionalColumns: response?.optional_columns ?? [],
  }
}

export function buildTableHeaders(
  response: CSVColumnResponse | undefined,
): CSVTableHeader[] {
  const { requiredColumns, optionalColumns } = normalizeColumns(response)

  return [
    ...requiredColumns.map((name) => ({ name, required: true })),
    ...optionalColumns.map((name) => ({ name, required: false })),
  ]
}

export function normalizeSummary(
  summary: CSVUploadSummaryResponse | undefined,
): CSVUploadSummary {
  return {
    rowsReceived: summary?.rows_received ?? 0,
    rowsProcessed: summary?.rows_processed ?? 0,
    errors: summary?.errors ?? {},
  }
}
